import { Col, Row, Tabs } from "antd";
import { ContentHeader } from "../../components";
import {
    Chart as ChartJS,
    ArcElement,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { layThongTinCaNhan } from "../../services/nguoidung";
import { useEffect, useState } from "react";
import { NguoiDungResponse } from "../../models/nguoidung/NguoiDung";
import ThuNhapCaNhanBox from "./ThuNhapCaNhanBox";
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import { useDispatch } from 'react-redux';

ChartJS.register(
    ArcElement,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const ThuNhapCaNhan = () => {
    const [userInfo, setUserInfo] = useState<NguoiDungResponse>(new NguoiDungResponse);
    const [currentYear, setCurrentYear] = useState<number>(new Date().getFullYear());
    const dispatch = useDispatch();

    const layThongTinNguoiDung = async () => {
        try {
            dispatch(showLoadingScreen());
            var rs = await layThongTinCaNhan();
            setUserInfo(rs);
            dispatch(hideLoadingScreen());
        }
        catch (err: any) {
            dispatch(hideLoadingScreen());
        }
    }
    
    useEffect(() => {
        layThongTinNguoiDung();
    },[])

    return (
        <section>
            <ContentHeader title="Quản lý thu nhập" />
            <div className="card">
                <h3 className="text-center mt-4"><b>THÔNG TIN LƯƠNG VÀ CÁC KHOẢN THU NHẬP KHÁC</b></h3>
                <Row className="form-group ml-4">
                    <Col span="12">
                        <Row>
                            <Col span="5">Nhân viên: </Col>
                            <Col span="7"><label>{userInfo?.hoTen}</label></Col>
                        </Row>
                        <Row>
                            <Col span="5">Phòng ban: </Col>
                            <Col span="7"><label>{userInfo?.tenDonVi}</label></Col>
                        </Row>
                    </Col>
                    <Col span="12">
                        <Row>
                            <Col span="5">Chức vụ: </Col>
                            <Col span="7"><label>{userInfo?.tenChucVu}</label></Col>
                        </Row>
                    </Col>
                </Row>
                <Tabs className="ml-4" defaultActiveKey="5" items={[
                    {
                        key: '1',
                        label: currentYear - 4,
                        children:
                            <ThuNhapCaNhanBox year={currentYear - 4} />
                    },
                    {
                        key: '2',
                        label: currentYear - 3,
                        children:
                            <ThuNhapCaNhanBox year={currentYear - 3} />
                    },
                    {
                        key: '3',
                        label: currentYear - 2,
                        children:
                            <ThuNhapCaNhanBox year={currentYear - 2} />
                    },
                    {
                        key: '4',
                        label: currentYear - 1,
                        children:
                            <ThuNhapCaNhanBox year={currentYear - 1} />
                    },
                    {
                        key: '5',
                        label: currentYear,
                        children:
                            <ThuNhapCaNhanBox year={currentYear} />
                    },
                ]}>
                </Tabs>                
            </div>
        </section>)
}

export default ThuNhapCaNhan;